import React, { useEffect } from "react";
import * as app from "../../services/AppService";
import { useSelector, useDispatch } from "react-redux";
import { getData } from "../../store/data"; 
import Autocomplete from "../Autocomplete"
import { KeyValue } from "../../models/Core/key-value";
import { AutocompleteProps } from "../../models/autocomplete-props";

interface Props extends Omit<AutocompleteProps, 'options'> {
    withAllBranches?: boolean,
    withOutMainBranch?: boolean,
    onLoad?:(args:any) => any
}
export default function UserBranches(props: Props) {
    const dispatch: any = useDispatch();

    useEffect(() => {
        dispatch(getData("UserBranches", {}, (UserBranches: KeyValue[]) => {
            if (UserBranches && UserBranches.length > 0 && props.onLoad && typeof props.onLoad == "function") {
                var Branches = (props.withAllBranches && UserBranches.length > 1
                    ? [{ Value: app.translate("AllBranchs"), Key: "0" }, ...UserBranches]
                    : UserBranches).filter((r: KeyValue) => +r.Key !== 1 || !props.withOutMainBranch);
                if (Branches.length > 0)
                    props.onLoad(Branches);
            }
        }));
    }, []);

    const selector = useSelector((store: any) => store.data.UserBranches);
    const UserBranches = (props.withAllBranches && selector.length > 1
        ? [{ Value: app.translate("AllBranchs"), Key: "0" }, ...selector]
        : selector).filter((r: KeyValue) => +r.Key !== 1 || !props.withOutMainBranch);

    return (
        <Autocomplete id="UserBranches" label="Branch" {...props} options={UserBranches} />
    );
}
